// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"0882a35e","571":"19bdba1e","579":"05d86651","664":"4969f306","712":"423f80c6","773":"ab20aa0c","781":"6e46c839","887":"ba84cd5c","930":"24a61a11","937":"cdf77070"}[chunkId] + ".chunk.js";
};